import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface MandatoryTemplateParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface MandatoryTemplate {
    pageId: string;
    columnName: string;
    requiredFieldId: string;
    mandatoryStatus:string;
    tabName:string;
    groupName:string;
    tenantId:string;
    branchId:string;
    userId?:string;
    groupId?:number;
    parameters?: MandatoryTemplateParameter[];
    links?: any;
}

export interface MandatoryTemplateView extends MandatoryTemplate {
    checked: boolean;
}


export abstract class MandatoryTemplateData {
   
    abstract list(url: string): Observable<MandatoryTemplate[]>;
    abstract update(url: string, data: MandatoryTemplate[]): Observable<any>;
    abstract create(url:string,data:MandatoryTemplate[]):Observable<any>;
   
}
